module.exports = __webpack_public_path__ + "static/media/milford_heights_by_laws.7340da9b.pdf";